import axios from "axios";
import { toast } from "react-toastify";

export default async <T,>(url: string, data: T): Promise<T> => {
  try {
    await axios.put(url, data);
    toast("Item was successfully updated", {
      type: "success",
    });
  } catch (error: any) {
    toast(error, {
      type: "error",
    });
  }
  return data;
};
